
export class CountResult {
    key: number;
    count: number;
}
